/**
 * @fileoverview TypeScript interfaces for LogPlanCentroCosto collection
 * Based on model.json collection pbc_1909650630
 */

import { BaseRecord } from '../common/PocketBaseTypes';

/**
 * Main LogPlanCentroCosto interface representing a cost center process log
 */
export interface LogPlanCentroCosto extends BaseRecord {
  /** Collection ID for PocketBase */
  collectionId: string;
  /** Collection name for PocketBase */
  collectionName: string;
  
  /** Reference to orden_produccion collection (pbc_3129228651) */
  orden: string;
  
  /** Reference to centro_costo collection */
  centro_costo: string;
  
  /** Reference to users collection (operator role) - NEW FIELD */
  operario?: string;
  
  /** Reference to proceso_proveedor collection (provider role) - NEW FIELD */
  proceso_proveedor?: string;
  
  /** Reference to plan_centro_costo collection - NEW FIELD */
  log_plan?: string;
  
  /** Reference to tarea_orden collection - NEW FIELD */
  tarea_orden?: string;
  
  /** Task priority order (1, 2, 3...) - NEW FIELD */
  prioridad?: number;
  
  /** Plan order sequence (1, 2, 3...) - NEW FIELD - maintains original plan order */
  orden_plan?: number;
  
  /** Whether the task is ready to be executed - NEW FIELD */
  ready?: boolean;
  
  /** Percentage weight for this task (0-100) - NEW FIELD */
  porcentaje?: number;
  
  /** Process start date/time (optional) */
  inicio?: string;
  
  /** Process completion date/time (optional) */
  fin?: string;
  
  /** Auto-generated creation timestamp */
  created: string;
  
  /** Auto-generated update timestamp */
  updated: string;
  
  /** @deprecated Use operario instead */
  usuario?: string;
}

/**
 * Data structure for creating a new LogPlanCentroCosto
 */
export interface CreateLogPlanCentroCostoData {
  /** Reference to orden_produccion collection */
  orden: string;
  
  /** Reference to centro_costo collection */
  centro_costo: string;
  
  /** Reference to users collection (operator role) - NEW FIELD */
  operario?: string;
  
  /** Reference to proceso_proveedor collection (provider role) - NEW FIELD */
  proceso_proveedor?: string;
  
  /** Reference to plan_centro_costo collection - NEW FIELD */
  log_plan?: string;
  
  /** Reference to tarea_orden collection - NEW FIELD */
  tarea_orden?: string;
  
  /** Task priority order (1, 2, 3...) - NEW FIELD */
  prioridad?: number;
  
  /** Plan order sequence (1, 2, 3...) - NEW FIELD - maintains original plan order */
  orden_plan?: number;
  
  /** Whether the task is ready to be executed - NEW FIELD */
  ready?: boolean;
  
  /** Percentage weight for this task (0-100) - NEW FIELD */
  porcentaje?: number;
  
  /** Process start date/time (optional) */
  inicio?: string;
  
  /** Process completion date/time (optional) */
  fin?: string;
  
  /** @deprecated Use operario instead */
  usuario?: string;
}

/**
 * Data structure for updating an existing LogPlanCentroCosto
 */
export interface UpdateLogPlanCentroCostoData {
  /** Reference to orden_produccion collection (optional) */
  orden?: string;
  
  /** Reference to centro_costo collection (optional) */
  centro_costo?: string;
  
  /** Reference to users collection (operator role) - NEW FIELD */
  operario?: string;
  
  /** Reference to proceso_proveedor collection (provider role) - NEW FIELD */
  proceso_proveedor?: string;
  
  /** Reference to plan_centro_costo collection - NEW FIELD */
  log_plan?: string;
  
  /** Reference to tarea_orden collection - NEW FIELD */
  tarea_orden?: string;
  
  /** Task priority order (1, 2, 3...) - NEW FIELD */
  prioridad?: number;
  
  /** Plan order sequence (1, 2, 3...) - NEW FIELD - maintains original plan order */
  orden_plan?: number;
  
  /** Whether the task is ready to be executed - NEW FIELD */
  ready?: boolean;
  
  /** Percentage weight for this task (0-100) - NEW FIELD */
  porcentaje?: number;
  
  /** Process start date/time (optional) */
  inicio?: string;
  
  /** Process completion date/time (optional) */
  fin?: string;
  
  /** @deprecated Use operario instead */
  usuario?: string;
}

/**
 * Collection metadata for LogPlanCentroCosto
 */
export const LOG_PLAN_CENTRO_COSTO_COLLECTION = {
  name: 'log_plan_centro_costo',
  id: 'pbc_1909650630'
} as const;
